exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ANIMATION */\n/* SHADOWS */\n.ErrorAlert__alert__2fPsB {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 2;\n  text-align: left; }\n  @media (min-width: 768px) {\n    .ErrorAlert__alert__2fPsB .ErrorAlert__alert__2fPsB {\n      position: absolute; } }\n", ""]);

// exports
exports.locals = {
	"alert": "ErrorAlert__alert__2fPsB"
};